import { ellipsis, ellipsisMultiline } from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	table: {
		backgroundColor: tokens.colorNeutralBackground1,
		margin: `${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL} 0px ${tokens.spacingHorizontalL}`,
		padding: `0px ${tokens.spacingHorizontalS}`,
	},
	skillsText: {
		...ellipsisMultiline(2),
	},
	tableContainer: {
		height: "calc(100% - 64px)",
		overflowY: "auto",
	},
	container: {
		margin: `${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL} 0px ${tokens.spacingHorizontalL}`,
		padding: `0px ${tokens.spacingHorizontalS} 0px 0px`,
	},
	leftContainer: {
		backgroundColor: tokens.colorNeutralBackground3,
	},
	rightContainer: {
		margin: "0, 0, 0, auto",
		gap: tokens.spacingHorizontalL,
		padding: `0 ${tokens.spacingHorizontalS}`,
	},
	settingsPopover: {
		minWidth: "16rem",
		maxWidth: "30rem",
		maxHeight: "80%",
		padding: 0,
		overflow: "hidden auto",
	},
	queuesTitle: {
		fontWeight: tokens.fontWeightSemibold,
		fontSize: tokens.fontSizeBase400,
		padding: `${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL} 2px ${tokens.spacingHorizontalL}`,
	},
	queuesList: {
		padding: `0px ${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL}`,
	},
	queuesListHeader: {
		padding: `${tokens.spacingHorizontalS} 0px`,
	},
	queuesListContainer: {
		maxHeight: "400px",
		overflowY: "scroll",
	},
	queuesListItem: {
		padding: `${tokens.spacingHorizontalXXS} 0px`,
	},
	queueNameHeader: {
		width: "64rem",
	},
	queueName: {
		width: "64rem",
		fontSize: tokens.fontSizeBase400,
		fontWeight: tokens.fontWeightRegular,
		...ellipsis(),
	},
	estimatedTime: {
		width: "40rem",
		minWidth: "110px",
	},
	estimatedTimeContainer: {
		"& button:last-child": {
			visibility: "hidden",
		},
		"&:hover": {
			"& button:last-child": {
				visibility: "visible",
			},
		},
	},
	estimatedTimeInput: {
		width: "78px",
	},
	offerCalls: {
		width: "60rem",
	},
	offerCallsSwitch: {
		marginLeft: "-8px",
	},
	joinedToPopover: {
		minWidth: "20rem",
		maxWidth: "30rem",
		padding: 0,
	},
	doesntHaveClientStatusIcon: {
		transform: "rotate(45deg)",
	},
	joinToPopoverTrigger: {
		color: tokens.colorNeutralForeground1,
	},
	multiCheckbox: {
		marginLeft: "-8px",
	},
	multiCheckboxItem: {
		"&>label": {
			...ellipsis(),
		},
		width: "280px",
	},
	checkboxItem: {
		maxWidth: "100%",
		"&>label": {
			...ellipsis(),
		},
	},
	joinAll: {
		marginLeft: "8px",
		fontWeight: tokens.fontWeightMedium,
	},
	agentWorkload: {
		"&:hover, &:hover:active": {
			fontWeight: tokens.fontWeightSemibold,
		},
		color: tokens.colorNeutralForeground1,
	},
	searchInput: {
		width: "400px",
		backgroundColor: tokens.colorNeutralBackground1,
		margin: 0,
		border: "none",
	},
	filterGroupHeader: {
		display: "flex",
		justifyContent: "space-between",
	},
	cleanButtonSize: {
		minWidth: 0,
		padding: 0,
	},
	filterTrigger: {
		margin: "0",
	},
	generalFilterContainer: {
		width: "320px",
	},
	filterRadioGroup: {
		margin: "10px 7px",
	},
	filterSection: {
		margin: "15px",
	},
	radioElementBig: {
		width: "120px",
	},
	radioElementSmall: {
		width: "80px",
	},
	presenceElement: {
		maxWidth: "100%",
		margin: "0px 8px",
	},
	presenceMenu: {
		marginBottom: "10px",
	},
	tableHeader: {
		">tr": {
			"&:hover, &:hover:active": {
				backgroundColor: tokens.colorNeutralBackground1,
			},
		},
	},
	tableHeaderCell: {
		backgroundColor: tokens.colorNeutralBackground1,

		"&:hover, &:hover:active": {
			backgroundColor: tokens.colorNeutralBackground1,
		},
	},
	tableClass: {
		marginBottom: "20px",
	},
	additionalActionButton: {
		paddingRight: "0px",
		paddingLeft: "0px",
		minWidth: 0,
	},
	supervisorPanelContainer: {
		width: "100%",
		overflowY: "auto",
	},
	listItem: {
		backgroundColor: tokens.colorNeutralBackground1,
	},
	isNotJoinedBorder: {
		border: `2px solid ${tokens.colorPaletteRedBackground3}`,
	},
	isNotJoinedColor: {
		color: tokens.colorPaletteRedBackground3,
	},
});
